import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from './Breadcrumb';

// Sprint 2.4 (Enterprise Design System Foundation): consistent title + breadcrumb + actions-slot
// header for the new admin pages (EnterpriseConfiguration, GovernanceRequests, ComplianceCenter),
// and reusable for the modernized Dashboard.
const PageHeader = ({ title, subtitle, breadcrumbItems, actions }) => (
  <div className="ent-page-header">
    <div>
      {breadcrumbItems && <Breadcrumb items={breadcrumbItems} />}
      <h1 className="ent-page-header-title">{title}</h1>
      {subtitle && <div className="ent-page-header-subtitle">{subtitle}</div>}
    </div>
    {actions && <div className="ent-page-header-actions">{actions}</div>}
  </div>
);

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.node,
  breadcrumbItems: PropTypes.array,
  actions: PropTypes.node
};

export default PageHeader;
